<i18n>
{
	"en": {
		"title" : "Create Outbound EDI Setup",
		"endpoint" : "Destination",
		"sender" : "Sender",
		"recipient" : "Recipient",
		"messageFormatDescription" : "Message Format",
		"messageTypeDescription" : "Message Type",
		"ediMessageTransportMethod" : "Sending method",
		"notifyEdipartSetupCreated" : "EDI part setup was created successfully",
		"bundleSupport": "EDI message bundle on Trip?"
	},
	"no":{
		"title" : "Opprett utgående EDI oppsett",
		"endpoint" : "Destinasjon",
		"sender" : "Sender",
		"recipient" : "Mottaker",
		"messageFormatDescription" : "Meldings Format",
		"messageTypeDescription" : "Meldings Type",
		"ediMessageTransportMethod" : "Sendingsmetode",
		"notifyEdipartSetupCreated" : "EDI part setup ble opprettet",
		"bundleSupport": "Bundling av edi meldinger (Tur)?"
	}
}
</i18n>

<template>
	<t-dialog
		:title="$t('title')"
		:isShown="isDialogShown"
		:icon="'settings'"
		iconType="bp"
		@close="close"
		@ok="add"
		@cancel="close"
	>
		<OutboundSettings
			:outboundEdiSetting="outboundEdiSettingTemplate"
		/>
	</t-dialog>
</template>

<script>

import { mapGetters, mapActions } from '../store/details/ediSetupDetails.store';
import OutboundSettings from '../editEdipart/OutboundSettings';
import { v4 as uuid } from 'uuid';
export default {
	components: { OutboundSettings },
	props: { isDialogShown: Boolean, },

	data() {
		return {
			outboundEdiSettingTemplate: {
				ssl:false,
				id: null,
				edipartId: null,
				sender:'',
				endpoint:'',
				recipient:'',
				createDate:'',
				description:null,
				messageType:2,
				allowUpdates:false,
				messageFormat:11,
				senderQualifier:'',
				enableBundling: false,
				transportMethod:3,
				endpointPassword:'',
				endpointUsername:'',
				recipientQualifier:'',
				messageTypeDescription:'Instruction',
				messageFormatDescription:'Timpex XML',
				transportMethodDescription:''
			}
		};
	},
	computed: { ...mapGetters(['edipart']) },
	methods:{
		...mapActions(['executeAddOutboundSettingAndPatch']),
		close() {
			this.$emit('close');
		},
		onBundleSupport(supportsBundling) {
			this.bundleSupport = supportsBundling;
		},
		add() {
			this.outboundEdiSettingTemplate.id = uuid();
			this.outboundEdiSettingTemplate.edipartId = this.edipart.id;
			this.executeAddOutboundSettingAndPatch(this.outboundEdiSettingTemplate);
			this.$notify({
				type: 'success',
				title: this.$t('notifyEdipartSetupCreated')
			});
		},
	}
};
</script>

<style lang="scss" scoped>
	@import '~@/components/evergreen/scss/colors';
	@import '~@/components/evergreen/scss/text';
.details{
	display: grid;
	grid-template-columns: repeat(4, minmax(220px, 1fr));
	column-gap: 20px;
	row-gap: 20px;
}

.transport-method-grid{
	display:grid;
	grid-template-columns: 100px;
}

hr {
	grid-column: 1 / auto-fill;
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	margin-top: 0;
	margin-bottom: 0;
	border: 0;
	}
</style>